const ID_KEY = 'savedUserId'

export const getUserSavedId = () => {
  return window.localStorage.getItem(ID_KEY)
}

export const saveUserId = userId => {
  window.localStorage.setItem(ID_KEY, userId)
}

export const destroyUserId = () => {
  window.localStorage.removeItem(ID_KEY)
}

export default { getUserSavedId, saveUserId, destroyUserId }
